import React from 'react';
import { useSelector } from 'react-redux';
import FieldSet from './FieldSet';
import FormControlFactory from './FormControlFactory';
import AccordionFieldSet from './AccordionFieldSet';
import { IFieldSetSettings } from '../types/IFormSettings';
import { fieldSetSelector } from '../selectors/formBuilder.selector';

function FieldSetBuilder({
    formName,
    controls,
    fieldSetName,
    visible,
    disabled,
    description,
    tooltip,
    collapsable,
    iconSrc,
}: IFieldSetSettings) {
    // Get visibility from state (show/hide feature) ==> only yet implemented for <FieldSet />
    const fieldSet = useSelector(fieldSetSelector(formName, fieldSetName));
    const isVisible = fieldSet && fieldSet.visible;

    const renderFormControl = controls.map((control) => (
        <FormControlFactory
            formName={formName}
            key={control.controlName}
            controlName={control.controlName}
            type={control.type}
        />
    ));

    if (collapsable) {
        return (
            <AccordionFieldSet
                controls={controls}
                fieldSetName={fieldSetName}
                description={description}
                disabled={disabled}
                visible={visible} // isVisible intentionally not in use here yet.
                iconSrc={iconSrc}
            >
                {renderFormControl}
            </AccordionFieldSet>
        );
    }

    return isVisible === false ? (
        <></>
    ) : (
        <FieldSet
            controls={controls}
            fieldSetName={fieldSetName}
            description={description}
            tooltip={tooltip}
            disabled={disabled}
        >
            {renderFormControl}
        </FieldSet>
    );
}

export default FieldSetBuilder;
